import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Services from './components/Servies';
import Pricing from './components/Pricing'
import Contact from './components/Contact';
import About from './components/About'
import PrivacyPloicy from './components/PrivacyPolicy';
import Terms from './components/TermsOfService';
import SupportCenter from './components/SupportCenter'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path = "/service" element = {<Services/>}/>
          <Route path = "/pricing" element = {<Pricing/>}/>
          <Route path="/contact" element = {<Contact/>}/>
          <Route path = "/about" element ={<About/>}/>
          <Route path = "/terms" element = {<Terms/>}/>
          <Route path="/privacy" element = {<PrivacyPloicy/>}/>
          <Route path = "/support" element ={<SupportCenter/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
